import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';

export const DocumentTitle = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const splitPath = location.pathname.split('/');

  const path = `/${
    splitPath[2] && !['show', 'edit', 'create'].includes(splitPath[2])
      ? splitPath[2]
      : splitPath[1]
  }`;

  const translatedPath = t(
    `breadcrumbs.${path === '/' ? 'home' : path.replace(/\//g, '')}`,
    {
      defaultValue: null
    }
  );

  document.title = `Extranet | Assurmax${
    translatedPath ? ` - ${translatedPath}` : ''
  }`;

  return null;
};
